/**
 * Firebase Manager - Analytics Only
 *
 * This file now only handles Firebase Analytics.
 * Storage has been migrated to Cloudflare R2 (see storageManager.ts)
 * Auth has been removed (R2 uses public access)
 */

import { initializeApp } from "firebase/app";
import {
  getAnalytics,
  logEvent,
  setAnalyticsCollectionEnabled,
} from "firebase/analytics";
import AppConfig from "config/AppConfig";

// Firebase configuration for Analytics only
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase (Analytics only)
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Analytics 설정
const config = AppConfig.getInstance();

// Analytics가 비활성화된 경우 수집 중지
if (!config.isAnalyticsEnabled()) {
  setAnalyticsCollectionEnabled(analytics, false);
}

// ============================================
// STORAGE FUNCTIONALITY MOVED TO storageManager.ts
// ============================================
// Storage functions (getFeaturedWorksThumbnails, getFeaturedWorksImages)
// have been moved to src/api/storageManager.ts
// to use Cloudflare R2 instead of Firebase Storage.
//
// Import from storageManager.ts instead:
// import { getFeaturedWorksThumbnails, getFeaturedWorksImages } from 'api/storageManager';
// ============================================

// Analytics 이벤트 로깅 함수
export const logAnalyticsEvent = (
  eventName: string,
  eventParams?: { [key: string]: any }
) => {
  try {
    // Analytics가 활성화된 경우에만 이벤트 전송
    if (config.isAnalyticsEnabled()) {
      logEvent(analytics, eventName, eventParams);
    }
  } catch (error) {
    console.error("Analytics event logging failed:", error);
  }
};

// Analytics 활성화 상태 확인 함수
export const isAnalyticsEnabled = () => {
  return config.isAnalyticsEnabled();
};

export { analytics };
